import styled from '@emotion/styled';

export const StyledProductGridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: ${ props => `1px solid ${ props.theme.products.colors.border }` };
  padding-bottom: 0.75em;

  .preview {
    width: 100%;
    position: relative;
    min-height: 200px;

    a {
      &:hover, &:focus, &:active {
        background: transparent;
      }

      > svg {
        max-width: 50%;
      }

      > * {
        margin: 0 auto;
      }

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      max-height: none;
      padding: 0;
      margin: 0 auto;
    }

    .cds--loading {
      top: auto;
      left: auto;
    }

    svg.image {
      max-width: 70% !important;
      stroke: #AFAEAE;
    }

    .image {
      &.placeholder {
        width: 120px;
      }

      object-fit: contain;
      display: block;
      height: auto;
      max-height: 160px;
      max-width: 100%;
      width: auto;
      margin: 0 auto;
    }

    /* TODO: Remove this after Black Friday  */
    .blackFriday {
      position: absolute;
      top: 5px;
      right: 5px;

      img {
        width: 100px;
        height: auto;
      }
    }

    .badges {
      position: absolute;
      top: 4px;
      left: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      z-index: 9;

      .badge {
        &.isResealed {
          font-size: 0.625rem;
        }

        &.isEol {
          color: ${ props => props.theme.products.colors.isEol };
        }

        background-color: rgba(255, 255, 255, 0.7);
        margin: 2px 0;
        font-size: 0.675rem;
        border-radius: 0;
        cursor: pointer;
        outline: 0;
        text-align: center;
        padding: 0 10px;
        text-transform: uppercase;
        font-weight: 600;
      }
    }

    .promotions {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 35px;
      z-index: 1;
      background-color: ${ props => props.theme.products.colors.promotionsRibbon };

      svg {
        height: 20px;
        width: 25px;
        margin-right: 5px;
      }

      p {
        font-size: 0.875em;
        color: ${ props => props.theme.colors.darkGray };
      }
    }
  }

  .helperButtons {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    color: ${ props => props.theme.colors.darkGray };
    font-size: 0.875rem;
    flex-direction: column;

    > div, button {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 35px;
      background-color: #F4F9F4;
      margin: 5px 0;
      width: 100%;
      max-width: 100%;
    }

    .csp a {
      color: #3A3A3A;
      font-size: 13px;
    }

    svg:not(.cds--loading__svg) {
      stroke: ${ props => props.theme.colors.altOrange };
    }

    button {
      font-size: inherit;
      color: inherit;
      border: 0;
      outline: 0;
      box-shadow: none;
      cursor: pointer;
    }

    p {
      display: flex;
      align-items: center;
      color: inherit;
      font-size: inherit;
      line-height: 1rem;
    }

    .resealed {
      svg {
        margin-right: 5px;
        stroke: ${ props => props.theme.products.colors.isResealed };
      }
    }
  }

  .details .minQuantity,
  .minQuantity {
    margin: 5px 0;
    line-height: 1rem;
    font-size: 0.925rem;
    font-weight: normal;
    color: ${ props => props.theme.colors.darkGray };
    white-space: nowrap;

    svg {
      position: relative;
      top: 3px;
      margin-right: 7px;
      transform: scale(0.9);
    }
  }

  .details {
    padding: 0 14px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: 60%;
    max-width: 100%;

    span.danger { 
      color: ${ props => props.theme.colors.default }
    }

    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      max-width: 100%;
      width: 100%;
    }

    .title {
      &:hover {
        color: ${ props => props.theme.colors.blue } !important;
      }

      height: 62px;
      display: block;
      margin: 0.5rem auto;
      width: 100%;
      text-align: center;
      font-weight: 500;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: 0.9375em;
      line-height: 1.375em;
      color: ${ props => props.theme.colors.darkGray };
    }

    .code {
      display: flex;
      align-items: center;
      align-self: stretch;
      justify-content: center;
      min-width: 0;
      font-size: 0.875rem;
      line-height: 1rem;
      font-weight: 600;
      color: ${ props => props.theme.colors.darkGray };
      margin-bottom: 5px;

      .codeLabel {
        margin-right: 5px;
        flex: none;
      }

      .codeValue {
        flex: 0 1 auto;
        min-width: 0;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: normal;
      }

      .copy {
        cursor: pointer;
        margin-left: 6px;
        flex: none;
      }
    }

    .badges {
      display: flex;
      width: 100%;
      align-items: flex-end;
      flex-wrap: wrap-reverse;
      flex-direction: row-reverse;
      justify-content: center;

      .specialPriceValidTo {
        flex-direction: row;
        align-items: center;

        .badge {
          margin: 0;
        }
      }

      .badge {
        &.isEol,
        &.isClearance,
        &.specialPrice {
          color: ${ props => props.theme.colors.white };
          background-color: ${ props => props.theme.products.colors.isEol };
          font-size: 13px;
        }

        font-size: 0.875rem;
        margin: 2px 5px;
        padding: 2px 5px;
        border-radius: 6px;
      }
    }
  }

  .stock {
    margin: 5px auto;
    font-size: 0.875rem;
    text-align: center;
    line-height: 1.25rem;

    &.inStock {
      color: #3A3A3A;
      font-weight: 600;

      span {
        font-weight: normal;
      }
    }

    .rsvpDetails {
      color: ${ props => props.theme.colors.gray };
      font-size: 0.875rem;
      line-height: 1;
    }

    &.reserved {
      font-weight: 600;

      span {
        font-weight: 400;
      }
    }

    &.inStock,
    &.inStockAndReserved {
      span {
        color: ${ props => props.theme.products.colors.inStock };
      }

      span.reservedStock {
        color: #3A3A3A;
      }
    }

    &.outOfStock {
      span {
        color: ${ props => props.theme.colors.default };
        margin-left: 2px;
      }
    }

    &.inCsp span {
      color: ${ props => props.theme.colors.default };
    }

    &.onDemand {
      span {
        color: ${ props => props.theme.colors.darkGray };
      }
    }

    span.danger {
      margin: 0;
    }
  }

  .deliveryEstimate {
    margin-bottom: 5px;
  }

  .price {
    margin-top: 8px;
    align-items: center;
  }

  .buttonActions {
    width: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .productPriceRequest {
      margin-bottom: 10px;
      height: 40px;
    }

    > * {
      max-width: 200px;
      width: 100%;
    }
  }

  .addToWishlistContainer {
    height: 40px;
    min-height: 40px;
    position: relative;
    margin-top: 5px;
  }

  .addToCart {
    font-size: 0.875rem;
  }

  button {
    svg {
      display: inline-block;
      margin: 0 5px;
    }

    &.addToCart {
      color: ${ props => props.theme.colors.white };
      min-width: 0;
      width: 100%;
    }

    &.stockAlert {
      border: 1px solid ${ props => props.theme.colors.default };
      color: ${ props => props.theme.colors.default };
      background-color: transparent !important;
    }

    &.quantitySelect {
      min-width: 0;
      width: 25px;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    margin: 5px 0;
    height: 100%;
    width: 100%;
    min-width: 165px;
    max-height: 40px;
    max-width: 200px;
    min-height: 40px;
    font-size: 1em;
  }

  @media screen and (max-width: 767px) {
    .preview .promotions {
      margin: 0 10px;
      width: calc(100% - 20px);
    }
    
    .helperButtons .quickView {
      display: none;
    }
  }
`;

export const StyledProductListItem = styled(StyledProductGridItem)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height: 255px;
  padding: 25px 0;
  border: 0;

  + .productListItem {
    border-top: 1px solid ${ props => props.theme.products.colors.border };
  }

  .preview {
    display: flex;
    align-items: center;
    align-self: flex-start;
    top: 8px;
    min-width: 200px;
    max-width: 200px;
    max-height: 200px;
    flex-basis: auto;
    border: 1px solid ${ props => props.theme.products.colors.border };
    margin-right: 1.35rem;

    @media screen and (max-width: 1550px) {
      max-width: 190px;
      min-width: 190px;
      max-height: 190px;
      height: 190px;
    }
    @media screen and (max-width: 1400px) {
      max-width: 175px;
      min-width: 175px;
      max-height: 175px;
      height: 175px;
    }

    .badges {
      align-items: flex-start;
      left: 10px;
    }

    .badge {
      border-radius: 0;

      &.isResealed,
      &.onDemand {
        border-color: ${ props => props.theme.products.colors.isResealed };
        color: ${ props => props.theme.products.colors.isResealed };
      }

      &.savings {
        color: ${ props => props.theme.colors.default } !important;
        border-color: ${ props => props.theme.colors.default } !important;
      }
    }

    .cds--loading {
      text-align: center;
      margin: 0 auto;
    }

    .image {
      display: block;
      max-height: 175px;
      max-width: 85%;
    }
  }

  .details {
    padding: 0;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    flex-direction: row;
    flex-grow: 1;
    margin: 0;
    flex-basis: 100%;
    flex-wrap: nowrap;
    overflow: hidden;

    > div.info {
      width: 100%;
      max-width: calc(100% - 320px);
      min-width: 300px;
      overflow: hidden;
    }

    .title {
      @media screen and (max-width: 1550px) {
        font-size: 1.25rem;
        line-height: 1.4rem;
      }
      @media screen and (max-width: 1400px) {
        font-size: 1rem;
        line-height: 1.2rem;
      }

      &:hover {
        color: ${ props => props.theme.colors.blue } !important;
      }

      height: auto;
      font-size: 1.5rem;
      line-height: 1.65rem;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #3A3A3A;
      padding-right: 1rem;
    }

    .stock {
      margin: 0;
      text-align: left;
    }

    p:not(.resealed), div.stock {
      font-weight: 600;
      font-size: 14px;
      color: #3A3A3A;

      span {
        font-weight: normal;
        margin: 0 3px;
      }

      &.inCsp span {
        color: ${ props => props.theme.colors.default };
      }

      svg {
        &.copy {
          cursor: pointer;
          top: 2px;
          stroke: ${ props => props.theme.colors.altOrange };
        }

        position: relative;
        margin-left: 2px;
      }
    }

    .deliveryEstimate {
      margin: 3px 0;
      color: #3A3A3A;

      span {
        font-weight: 600;
      }
    }

    .badges {
      width: auto;
      flex-direction: row;
      flex-wrap: nowrap;

      .badge {
        display: flex;
        align-items: center;
        height: 20px;
        margin-left: 5px;
        line-height: 1rem;
        justify-content: center;
        text-align: center;
        font-size: 0.875rem;
      }

      .specialPriceValidTo {
        display: flex;
        flex-direction: column;
        align-items: center;

        .badge {
          border: 0;
          margin-bottom: 0;
        }
      }
    }
  }

  .helperButtons {
    background-color: transparent;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 8px;
    flex-direction: row;

    .csp {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #F4F9F4;
      height: 35px;
      width: 100%;
      max-width: 190px;

      a {
        color: #3A3A3A;
        font-size: 13px;
      }
    }

    button, p {
      &:first-of-type {
        margin-left: 0;
      }

      background-color: ${ props => props.theme.products.colors.quickViewButtonBg };
      width: 100%;
      max-width: 180px;
      justify-content: center;
      height: 35px;
    }
  }

  .quantitySelector {
    button, input {
      height: 40px;
      max-height: 40px;
    }
  }

  .priceContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    width: 320px;
    min-width: 320px;
    border-left: 1px solid ${ props => props.theme.products.colors.border };
    padding-left: 1rem;
    padding-right: 1px;

    .quantitySelect {
      width: 27px;
    }

    .productPriceRequest {
      width: 200px;
    }

    button {
      &.stockAlert {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 165px;
        max-width: 200px;
        border: 1px solid ${ props => props.theme.colors.default };
        color: ${ props => props.theme.colors.default };
        position: relative;

        .cds--loading {
          position: relative;
          left: 0;
          top: 0;
          width: 20px;
          height: 20px;
          margin: 0 10px 0 0;

          .cds--loading__svg,
          .cds--loading__stroke {
            stroke: ${ props => props.theme.colors.default };
          }
        }
      }

      &.addToCart {
        width: 200px;
      }

      min-height: 40px;
      height: 40px;
    }

    .price {
      align-items: flex-end;
      flex-grow: 0;
    }
  }

  .addToWishlistContainer {
    margin-top: 5px;
  }
`;

export const StyledProductTableItem = styled.tr`
  &:hover {
    background-color: inherit !important;
  }

  position: relative;
  height: 4.75rem !important;

  .supplierInfo {
    display: flex;
    gap: 10px;
    align-items: center;

    .badge {
      font-size: 12px;
    }

    .deliveryEstimate {
      font-size: 12px;
      color: inherit;
    }
  }

  .inStockAndReserved {
    display: flex;
    flex-direction: column;
  }

  td {
    text-align: center;
    vertical-align: center;
    border-left: 0 none !important;
    border-right: 0 none !important;
    color: ${ props => props.theme.isOpen
      ? props.theme.colors.white
      : props.theme.colors.gray
    } !important;
    background-color: ${ props => props.theme.isOpen
      ? '#041B54'
      : props.theme.colors.white
    } !important;
  }

  p {
    font-size: 0.875rem !important;
  }

  a {
    display: flex;
    align-items: center;
    color: inherit;
  }

  .thumbnail {
    padding: 5px;
    text-align: center;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      height: 60px;
      width: 100%;
      margin: 0 auto;
      background-color: ${ props => props.theme.isOpen
        ? props.theme.colors.white
        : 'transparent'
      };

      > svg {
        max-width: 70%;
        width: 100%;
        stroke: #3a3a3a;
      }
    }

    img {
      display: block;
      width: auto;
      max-width: 65px;
      max-height: 100%;
    }
  }

  .code,
  .stock,
  .stock.supplierOffer .stockAmount {
    color: inherit;
  }

  .code {
    .container {
      display: flex;
      align-content: center;
    }

    p {
      display: flex;
      align-items: center;

      a {
        &:hover {
          color: ${ props => props.theme.colors.blue };
        }
      }

      svg {
        position: relative;
        top: 2px;
        cursor: pointer;
        margin-left: 5px;
        stroke: ${ props => props.theme.colors.altOrange };
      }
    }
  }

  .name {
    a {
      &:hover {
        color: ${ props => props.theme.colors.blue };
      }

      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.375rem;
      text-align: left;
    }
  }

  .badges {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .specialPriceValidTo {
      span:not(.badge) {
        display: none;
      }

      margin: 0;
    }

    .badge {
      &.isEol,
      &.specialPrice {
        color: ${ props => props.theme.colors.white };
        background-color: ${ props => props.theme.products.colors.isEol };
        font-size: 13px;
      }

      &.isPromotional {
        border-radius: 0;
        border: 0;
        padding: 2px 5px;

        svg {
          height: 18px;
          width: 20px;
          color: ${ props => props.theme.products.colors.addToFavoriteText };
        }

        color: ${ props => props.theme.colors.darkGray };
        background-color: ${ props => props.theme.products.colors.promotionsRibbon };
      }

      margin: 4px 0;
      padding: 2px 5px;
      border-radius: 6px;
    }
  }

  .stock,
  .price,
  .promotions,
  .quantity,
  .details {
    text-align: center;
  }

  .price {
    align-items: center;

    .oldPrice {
      font-size: 1rem;
      line-height: 1.375em;
      ${ props => props.theme.isOpen && `
          color: ${ props.theme.colors.white };
        ` }
    }

    .currentPrice {
      font-size: 1.25rem;
      line-height: 1.68rem;
      color: ${ props => props.theme.isOpen
        ? props.theme.colors.white
        : props.theme.colors.default
      };
    }
  }

  .stockAlert {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    border: 0;
    background-color: transparent !important;
    color: ${ props => props.theme.isOpen
      ? props.theme.colors.white
      : props.theme.colors.default
    };

    svg {
      margin-right: 5px;
    }
  }

  .image {
    > * {
      margin: 0 auto;
    }
  }

  .minQuantity {
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 5px;
    color: ${ props => props.theme.isOpen
      ? props.theme.colors.white
      : props.theme.colors.darkGray
      };

    svg {
      position: relative;
      top: 3px;
      margin-right: 5px;
      transform: scale(0.85);
      stroke: ${ props => props.theme.isOpen
        ? props.theme.colors.white
        : props.theme.colors.darkGray
      };
    }
  }

  .quantitySelector {
    margin: 0 auto;
    max-width: 90px;
    width: 100%;
    background-color: ${ props => props.theme.colors.white };

    button,
    input {
      height: 35px;
      max-height: 35px;
    }
  }

  .details {
    color: inherit;

    button {
      background-color: transparent !important;
      outline: 0;
      box-shadow: none;
      border: 0;
      width: 100%;
      height: 30px;
    }

    svg {
      transform: ${ props => props.theme.isOpen
        ? 'rotate(180deg)'
        : 'rotate(0)'
      };
      transition: transform 0.2s ease;
    }
  }
`;

export const StyledProductTableItemDetails = styled.tr`
  > td {
    display: none;
    background-color: #fff !important;
    box-shadow: inset 0 0 0 2px #041B54;
    border: none;
    border-top: 2px solid #041B54;
    padding: 20px 11px 24px;

    ${ props => props.theme.isOpen && `
        display: table-cell;
      ` }
  }

  height: 0 !important;
  background-color: ${ props => props.theme.colors.lighterBlue } !important;
  transform: translateY(-100%);

  .data {
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    .title {
      font-size: 1rem;
      text-transform: uppercase;
      color: ${ props => props.theme.products.colors.addToFavoriteText };
      font-weight: 600;
      margin-bottom: 5px;
      text-align: left;
    }

    .attributeData {
      border: 1px solid ${ props => props.theme.products.colors.addToFavoriteBorder };

      .row {
        display: flex;
        align-items: center;
        padding: 5px 12px;
        background-color: ${ props => props.theme.colors.white };

        &.odd {
          background-color: ${ props => props.theme.products.colors.promotionsRibbon };
        }

        p {
          &.name {
            width: 38%;
            color: ${ props => props.theme.colors.gray };
          }

          &.values {
            color: ${ props => props.theme.colors.darkGray };
            flex-grow: 1;
          }

          font-size: 0.875rem;
          text-align: left;
        }
      }
    }
  }

  .cds--loading {
    margin: 0 auto;

    svg {
      transform: scale(0.75);
    }
  }

  a {
    margin: 1.5rem auto 0;
    height: 40px;
    width: 100%;
    max-width: 250px;
    border: 1px solid ${ props => props.theme.colors.blue };
    background-color: ${ props => props.theme.colors.white };
    text-align: center;
    line-height: 40px;
    font-size: 0.875rem;
    color: ${ props => props.theme.colors.blue };
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    svg {
      margin-left: 5px;
      transform: scale(0.85) rotate(-90deg);
    }
  }

  ${ props => props.theme.isOpen && `
      height: 3rem !important;
      transform: translateY(0);
    ` }
`;
